import KnowledgeBaseVideoLibrary from "./KnowledgeBaseVideoLibrary";

export default KnowledgeBaseVideoLibrary;
